module.exports = __webpack_public_path__ + "static/media/parking.cad5bf78.svg";